import { Input } from "shared/components/forms/Input";
import { SectionCard } from "shared/app/SectionCard";

interface PlanFormProps {
  register: any;
  headerExtra?: React.ReactNode;
  footer?: React.ReactNode;
}

export const PlanForm = (props: PlanFormProps) => {
  const { register, headerExtra, footer } = props;

  return (
    <SectionCard title="Plan" headerExtra={headerExtra} footer={footer}>
      <div className="divide-y divide-alpha-40">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <Input
              id="sqft"
              label="Size, sq.ft"
              placeholder="240"
              type="number"
              max={10000}
              {...register("sqft", (v) => parseInt(v) || undefined)}
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Input
                id="beds"
                label="Beds"
                placeholder="1"
                type="number"
                max={10}
                {...register("beds", (v) => parseInt(v) || undefined)}
              />
            </div>
            <div>
              <Input
                id="baths"
                label="Baths"
                placeholder="2"
                type="number"
                max={10}
                {...register("baths", (v) => parseInt(v) || undefined)}
              />
            </div>
          </div>
        </div>
      </div>
    </SectionCard>
  );
};
